import { ExternalUser, Maybe } from "../../../generated";

export interface ExternalUserState {
  pageValue: number,
  allExternalUsers: (Maybe<ExternalUser> | undefined)[],
  tabValue: number,
  searchValue: string,
  currentExternalUser: Maybe<ExternalUser> | undefined;
  clientExternalUserData: Maybe<ExternalUser> | undefined;
  adversaryExternalUserData: Maybe<ExternalUser> | undefined;
}

export const externalUserInitialState: ExternalUserState = {
  pageValue: 0,
  allExternalUsers: [],
  tabValue: 0,
  searchValue: '',
  currentExternalUser: null,
  clientExternalUserData: null,
  adversaryExternalUserData: null
};

export enum ExternalUserActionType {
  SET_PAGE_VALUE = "setPageValue",
  SET_ALL_EXTERNAL_USERS = 'setAllExternalUsers',
  SET_TAB_VALUE = 'setTabValue',
  SET_SEARCH_VALUE = 'setSearchValue',
  SET_CURRENT_EXTERNAL_USER = 'setCurrentExternalUser',
  SET_CLIENT_EXTERNAL_USER_DATA = 'setClientExternalUserData',
  SET_ADVERSARY_EXTERNAL_USER_DATA = 'setAdversaryExternalUserData'
}

export type ExternalUserAction =
  | { type: ExternalUserActionType.SET_PAGE_VALUE, pageValue: number }
  | { type: ExternalUserActionType.SET_ALL_EXTERNAL_USERS, allExternalUsers: (Maybe<ExternalUser> | undefined)[] }
  | { type: ExternalUserActionType.SET_TAB_VALUE, tabValue: number }
  | { type: ExternalUserActionType.SET_SEARCH_VALUE, searchValue: string }
  | { type: ExternalUserActionType.SET_CURRENT_EXTERNAL_USER, currentExternalUser: Maybe<ExternalUser> | undefined }
  | { type: ExternalUserActionType.SET_CLIENT_EXTERNAL_USER_DATA, clientExternalUserData: Maybe<ExternalUser> | undefined }
  | { type: ExternalUserActionType.SET_ADVERSARY_EXTERNAL_USER_DATA, adversaryExternalUserData: Maybe<ExternalUser> | undefined }

export const externalUserReducer = (
  state: ExternalUserState,
  action: ExternalUserAction
): ExternalUserState => {
  switch (action.type) {
    case ExternalUserActionType.SET_ALL_EXTERNAL_USERS:
      return {
        ...state,
        allExternalUsers: action.allExternalUsers
      }

    case ExternalUserActionType.SET_PAGE_VALUE:
      return {
        ...state,
        pageValue: action.pageValue
      }

    case ExternalUserActionType.SET_TAB_VALUE:
      return {
        ...state,
        tabValue: action.tabValue,
      };

    case ExternalUserActionType.SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.searchValue,
      };

    case ExternalUserActionType.SET_CURRENT_EXTERNAL_USER:
      return {
        ...state,
        currentExternalUser: action.currentExternalUser,
      };

    case ExternalUserActionType.SET_CLIENT_EXTERNAL_USER_DATA:
      return {
        ...state,
        clientExternalUserData: action.clientExternalUserData,
      };

    case ExternalUserActionType.SET_ADVERSARY_EXTERNAL_USER_DATA:
      return {
        ...state,
        adversaryExternalUserData: action.adversaryExternalUserData,
      };

    default:
      return state;
  }
};
